.indicator {
  animation: appear 150ms ease-out;
}

@keyframes appear {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .indicator {
    animation: none;
    transition: none !important;
  }
}